import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Timestamp } from '@dixa/lib-shared-habla';
import { validate as validateUUID } from 'uuid';
import { analytics } from 'app/utils/segment';
export function teamConversationSubTitleRenderer(params) {
    var _a, _b, _c;
    const { metaConversation } = params;
    const { conversation } = metaConversation;
    const { last_message_created_at: lastMessageCreatedAt } = conversation;
    const separator = ' · ';
    const CSID = metaConversation.conversation.id;
    const queueName = validateUUID((_b = (_a = conversation.queue) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '')
        ? null // There is a bug in backend where they return uuid instead of name. We don't want to show uuid.
        : (_c = conversation.queue) === null || _c === void 0 ? void 0 : _c.name;
    return (_jsxs(_Fragment, { children: [CSID && _jsx("span", { children: `#${CSID}` }), lastMessageCreatedAt && (_jsxs(_Fragment, { children: [separator, _jsx("span", Object.assign({ onClick: () => analytics.conversationsTimestampClicked({
                            context: 'created',
                        }) }, { children: _jsx(Timestamp, { relative: true, time: lastMessageCreatedAt }) }))] })), queueName && (_jsx(_Fragment, { children: _jsxs("span", { children: [separator, queueName] }) }))] }));
}
